import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgMonitorCloud = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-monitor-cloud';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M7.96 3.265a2.8 2.8 0 0 0-1.916 1.014c-.271.326-.404.56-.532.941-.075.222-.13.324-.18.334-.151.03-.553.218-.747.349a3.8 3.8 0 0 0-.848.844c-.336.506-.47.968-.473 1.633-.003.515.041.754.214 1.181.274.676.904 1.315 1.557 1.58.53.215.661.224 3.306.209 2.715-.016 2.612-.006 3.219-.301.234-.114.384-.23.684-.528.411-.409.579-.665.741-1.127a3.1 3.1 0 0 0-.231-2.504c-.162-.284-.627-.776-.914-.967-.218-.146-.631-.343-.774-.369-.053-.01-.1-.097-.166-.305-.292-.922-1.185-1.755-2.06-1.922a4 4 0 0 0-.88-.062M13 4v.76h6.24v10.48H4.76V13H3.24v3.76h8v2.48H7v1.52h10v-1.52h-4.24v-2.48h8V3.24H13zm-4.261.879c.57.278.82.798.821 1.707v.366l.55.015c.501.014.568.025.75.121.269.142.512.401.648.692.098.21.112.288.112.62 0 .333-.014.41-.113.624a1.63 1.63 0 0 1-.667.703l-.18.093H5.74l-.18-.093a1.63 1.63 0 0 1-.667-.703c-.099-.214-.113-.291-.113-.624 0-.332.014-.41.112-.62.136-.291.379-.55.648-.692.182-.096.249-.107.75-.121l.55-.015v-.366c.001-.651.092-.996.353-1.339.119-.156.387-.348.598-.428.233-.089.705-.059.948.06"
    })
  }));
});
export default SvgMonitorCloud;